import { LingoLiftProduct } from '../types/common-enums';

export const isLingoLiftProduct = (product: LingoLiftProduct | string) => {
  return product === LingoLiftProduct.LingoLift;
};

export const isListenWiseProduct = (product: LingoLiftProduct | string) => {
  return product === LingoLiftProduct.ListenWise;
};
